export default __webpack_public_path__ + "static/reviews-img-d0698200833bda802f83a0f9acca4a03.jpg";